import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const CheckboxCheckSize24Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0001 9.5C18.3906 9.10948 18.3906 8.47631 18.0001 8.08579C17.6096 7.69526 16.9764 7.69526 16.5859 8.08579L10.293 14.3787L7.00012 11.0858C6.6096 10.6953 5.97643 10.6953 5.58591 11.0858C5.19538 11.4763 5.19538 12.1095 5.58591 12.5L9.58591 16.5C9.97643 16.8905 10.6096 16.8905 11.0001 16.5L18.0001 9.5Z"
            fill="var(--magritte-ui-icon-color)"
        />
    </svg>
);
const CheckboxCheckSize24 = hoc<'CheckboxCheckSize24'>(forwardRef(CheckboxCheckSize24Component), 'CheckboxCheckSize24');
export default CheckboxCheckSize24;
